import React, {useState, useEffect} from 'react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {DeviceViewModel} from "../../../models/device.view-model";
import {WithDevice} from "../../composers/with-device";

export class SwitchProps extends BaseProps {
  label: String;
  badgeLabel: String;
  activeButtonClassName: String;
  animationDurationMS: Number = 100;
  isActive: Boolean;
  shouldRenderBadge: Boolean;
  device: DeviceViewModel;
  onClick: Function;
  containerClassName: String;
  buttonContentClassName: String;
}

export const Switch = WithDevice((props: SwitchProps) => {
  const [active, setActive] = useState(props.isActive);

  useEffect(() => {
    setActive(props.isActive);
  },[props.isActive]);

  const containerProps = {
    className: ['switch-button-container', props.label ? 'switch-text-button-container' : '', props.containerClassName ? props.containerClassName : ''].join(' '),
    onClick: async () => {
      props.onClick && setTimeout(() => props.onClick(!active), props.animationDurationMS);

      await setActive(!active);
    }
  }

  const buttonContentClassName: String = [props.buttonContentClassName].join(' ');
  const activeButtonContentClassName: String = active && ['switch-active-button-content', props.activeButtonClassName].join(' ');
  const badgeDesktopClassName: String = ['switch-badge-icon-desktop', active ? 'switch-badge-active-icon-desktop' : ''].join(' ');
  const badgeMobileClassName: String = ['switch-badge-icon-mobile', active ? 'switch-badge-active-icon-mobile' : ''].join(' ');

  const badgeProps = {
    badgeLabel: props.device.isSmallView ? props.badgeLabel : `(${props.badgeLabel})`,
    className: props.device.isSmallView ? badgeMobileClassName : badgeDesktopClassName
  }

  return (
    <div className={'switch-container'}>
      <div {...containerProps}>
        <div className={['switch-button-content', props.label ? 'switch-text-button-content' : '', activeButtonContentClassName, buttonContentClassName].join(' ')}>
          {props.label}
        </div>
      </div>
      {
        props.shouldRenderBadge && <div className={badgeProps.className}>
          {badgeProps.badgeLabel}
        </div>
      }
    </div>
  )
});
